import React from "react";
import Helmet from "react-helmet";

export const SEO = ({ title, meta = [] }) => {
  const defaultTitle = "Medpro | Đặt khám trực tuyến";
  return (
    <Helmet
      title={title || defaultTitle}
      htmlAttributes={{ lang: "vi" }}
      meta={meta}
    />
  );
};
